import React from "react";
import {useTranslation} from "react-i18next";
import {PromoSection} from "../common/promo_section";
import {graphql, useStaticQuery} from "gatsby";
import GatsbyImage from "gatsby-image";

export const Section1: React.FC = () => {
  const {t} = useTranslation();

  const data = useStaticQuery(graphql`
  query {
  promo: file(relativePath: {eq: "promo/contact.jpg"}) { ...promoImage } 
  }`)

  return (
    <PromoSection>
      <div className="page-promo-text">
        <h1>{t('contact.section1.heading')}</h1>
        <p>{t('contact.section1.description')}</p>
      </div>
      <div className="page-promo-image">
        <div className="image-holder">
          <div className="image">
            <GatsbyImage
              style={{height: "100%", width: "100%"}}
              fluid={data.promo.childImageSharp.fluid}
            />
          </div>
        </div>
      </div>
    </PromoSection>
  )
}

